function _classCallCheck(instance, Constructor) {if (!(instance instanceof Constructor)) {throw new TypeError("Cannot call a class as a function");}}function _defineProperties(target, props) {for (var i = 0; i < props.length; i++) {var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);}}function _createClass(Constructor, protoProps, staticProps) {if (protoProps) _defineProperties(Constructor.prototype, protoProps);if (staticProps) _defineProperties(Constructor, staticProps);return Constructor;}import "./modal.scss";
import template from "./modal.html";

export { ModalAlertComponent } from "../alert/modal-alert.component";
export { ModalConfirmComponent } from "../confirm/modal-confirm.component";
export { ModalPromptComponent } from "../prompt/modal-prompt.component";
export { ModalMagnificComponent } from "../magnific/modal-magnific.component";
export { ModalCustomComponent } from "../custom/modal-custom.component";

export var ModalComponent = {
  template: template,
  bindings: {
    modal: "=" },

  controller: /*#__PURE__*/function () {ModalComponentController.$inject = ["$scope", "$element", "$compile", "LayoutService", "ModalsService"];
    function ModalComponentController($scope, $element, $compile, LayoutService, ModalsService) {
      "ngInject";_classCallCheck(this, ModalComponentController);
      this.ModalsService = ModalsService;
      this.$scope = $scope;
      this.$element = $element;
      this.$compile = $compile;

      this.modal = {};
    }_createClass(ModalComponentController, [{ key: "$postLink", value: function $postLink()

      {
        var modalOptions = this.modal.options || {};
        var $placeholder = this.$element.find('.ui-modal-transcluded');
        this.renderTemplate(modalOptions, $placeholder);
      } }, { key: "renderTemplate", value: function renderTemplate(_ref,

      $placeholder) {var template = _ref.template,$scope = _ref.$scope;
        if (
        !template ||
        !$placeholder && !$placeholder.length)
        return '';
        var modal$scope = $scope || this.$scope;
        modal$scope.$modal = this.modal;
        var compiledTemplate = this.$compile(template)(modal$scope);
        $placeholder.append(compiledTemplate);
      } }, { key: "close", value: function close()

      {
        this.modal.close();
      } }]);return ModalComponentController;}() };